import { css } from '@headout/pixie/css';
import { strings } from 'const/strings';

const LoaderFallback = ({ isClosing }: { isClosing?: boolean }) => (
  <div
    className={css({
      display: 'flex',
      position: 'absolute',
      marginTop: '-9px',
      transform: isClosing ? 'scale(0)' : 'scale(1)',
      transition: 'transform 200ms cubic-bezier(.42, 0, .58, 1)',
    })}
  >
    <div
      className={css({
        textStyle: 'Semantics/CTA/Regular',
        whiteSpace: 'nowrap',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'semantic.text.grey.2',
      })}
    >
      {strings.POWERED_BY}
    </div>
    <div
      style={{
        position: 'absolute',
        left: '-5px',
        bottom: '-12.43px',
        width: '48px',
        height: '48px',
        background:
          'radial-gradient(56.44% 54.66% at 42.22% 51.16%, #FFF 0%, #FFF 44.26%, rgba(255, 255, 255, 0.80) 71.26%, rgba(255, 255, 255, 0.00) 87.92%)',
      }}
    />
    <div
      style={{
        position: 'absolute',
        bottom: '-12.43px',
        right: '-7.8px',
        width: '48px',
        height: '48px',
        background:
          'radial-gradient(56.44% 54.66% at 42.22% 51.16%, #FFF 0%, #FFF 44.26%, rgba(255, 255, 255, 0.80) 71.26%, rgba(255, 255, 255, 0.00) 87.92%)',
      }}
    />
    <svg
      width="171"
      height="57"
      viewBox="0 0 171 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={css({ zIndex: 1 })}
    >
      <path
        d="M40.0369 41.1439C38.99 34.5314 30.456 31.519 22.4825 32.7821C18.3489 33.4372 12.9218 36.193 8.73754 39.2527C8.60246 39.0635 8.37957 38.8339 8.03172 38.6921C7.37655 38.4253 0.585119 37.9491 0.0751701 39.0534C-0.431401 40.151 1.75361 44.4096 2.70259 45.4126C2.39864 46.0407 2.27031 46.6182 2.34799 47.1147C2.42904 47.6212 2.7296 48.1312 3.20578 48.6344C2.61478 49.8974 1.8583 54.5984 2.67895 55.4832C3.50635 56.3748 9.81823 53.825 10.3586 53.3691C10.6895 53.0888 10.828 52.7477 10.8854 52.5215C12.9455 53.1496 15.1946 53.646 17.4067 53.9466L19.1391 55.6554C19.7133 56.2228 20.4832 56.5538 21.2904 56.5673C22.1482 56.5842 23.3977 56.5403 24.9377 56.2971C26.6871 56.0202 28.2777 55.571 29.3246 55.2333C30.1216 54.9766 30.7835 54.416 31.1719 53.6731L32.0804 51.9203C37.0819 49.5969 40.7664 45.757 40.0369 41.1439ZM23.6679 35.5581C30.3344 34.501 35.8324 36.9697 37.5783 39.9923C35.2008 39.2088 31.4826 38.3138 24.3129 39.4485C17.3695 40.5495 11.1286 42.7784 7.21783 44.5041C10.0816 41.5896 16.6705 36.6658 23.6679 35.5581ZM25.3531 51.0389C18.2138 52.1702 9.12591 49.4651 5.83658 47.6989C10.0479 48.0265 18.3996 48.2021 25.5186 47.0741C31.5569 46.1184 35.8729 44.3454 38.0343 42.8932C37.2035 46.2332 32.077 49.9751 25.3531 51.0389Z"
        fill="#8000FF"
      />
      <path
        d="M170.203 42.6252H165.623V50.2908C165.623 52.1357 165.655 52.2947 167.372 52.2947H170.203V55.8571H166.514C163.142 55.8571 161.552 54.7439 161.552 50.7043V42.6252H158.498V39.0627H161.552V34.4824H165.623V39.0627H170.203V42.6252Z"
        fill="#8000FF"
      />
      <path
        d="M146.766 56.1094C143.14 56.1094 140.723 53.7557 140.723 48.9845V39.0605H144.794V47.585C144.794 51.3701 145.78 52.4197 147.911 52.4197C150.265 52.4197 152.428 49.7797 152.428 45.8992V39.0605H156.499V55.855H152.428V54.8053C152.428 53.7875 152.651 53.1831 152.937 52.5152C153.064 52.2289 153.255 51.7836 152.841 51.6882C152.587 51.6246 152.491 51.8154 152.364 52.0699C151.537 53.7239 149.692 56.1094 146.766 56.1094Z"
        fill="#8000FF"
      />
      <path
        d="M130.067 38.8086C135.315 38.8086 138.464 42.6891 138.464 47.4603C138.464 52.2314 135.315 56.1119 130.067 56.1119C124.819 56.1119 121.67 52.2314 121.67 47.4603C121.67 42.6891 124.819 38.8086 130.067 38.8086ZM130.067 52.4223C132.834 52.4223 134.393 50.1957 134.393 47.4603C134.393 44.7248 132.834 42.4983 130.067 42.4983C127.3 42.4983 125.741 44.7248 125.741 47.4603C125.741 50.1957 127.3 52.4223 130.067 52.4223Z"
        fill="#8000FF"
      />
      <path
        d="M115.317 32.9551H119.388V55.8566H115.317V55.125C115.317 54.4888 115.476 53.9799 115.762 53.4074C115.921 53.0893 116.048 52.7712 115.698 52.644C115.412 52.5486 115.285 52.8667 115.221 52.9621C114.044 54.7115 112.454 56.111 109.91 56.111C105.552 56.111 102.594 52.2941 102.594 47.4594C102.594 42.6246 105.552 38.8077 109.91 38.8077C112.518 38.8077 114.299 40.08 115.221 41.9248C115.285 42.0521 115.476 42.4656 115.794 42.3065C116.112 42.1475 115.921 41.7658 115.762 41.4477C115.476 40.8752 115.317 40.3663 115.317 39.6983V32.9551ZM110.864 52.4213C113.536 52.4213 115.317 50.1312 115.317 47.4594C115.317 44.7875 113.536 42.4974 110.864 42.4974C108.001 42.4974 106.665 44.7875 106.665 47.4594C106.665 50.1312 108.001 52.4213 110.864 52.4213Z"
        fill="#8000FF"
      />
      <path
        d="M84.2988 51.2454C84.2988 47.5239 87.0343 46.1562 90.4059 45.9653C93.3958 45.8063 96.0358 46.0925 96.004 44.534C95.9722 43.3889 95.5269 42.1166 92.6324 42.1166C89.7697 42.1166 89.0382 43.2935 88.8155 44.6612H84.8078C85.3803 40.4308 89.0064 38.8086 92.7597 38.8086C96.6084 38.8086 100.075 40.0809 100.075 46.5697V55.8575H96.004V54.6806C96.004 53.9172 96.1949 53.3765 96.4811 52.8358C96.6084 52.5495 96.7356 52.2314 96.4493 52.1042C96.1313 51.9769 96.004 52.295 95.9404 52.4541C94.9862 54.776 93.1413 56.1119 90.1514 56.1119C87.0025 56.1119 84.2988 54.0763 84.2988 51.2454ZM96.004 47.2058C95.0498 48.2555 93.523 48.4145 91.1057 48.669C89.3562 48.8598 88.3702 49.5278 88.3702 51.0227C88.3702 52.4223 89.7061 53.3129 91.5828 53.0584C93.7457 52.7721 95.9722 51.3726 96.004 47.2058Z"
        fill="#8000FF"
      />
      <path
        d="M82.5511 47.2376C82.5511 47.6829 82.5193 48.001 82.4557 48.4781H70.2416C70.5278 51.0227 72.1818 52.5495 74.7265 52.5495C76.6667 52.5495 77.6528 51.4998 78.1299 50.0049H82.2649C81.5333 53.4719 79.1795 56.1119 74.6946 56.1119C69.2555 56.1119 66.2656 52.4541 66.2656 47.4603C66.2656 42.212 69.51 38.8086 74.631 38.8086C78.5116 38.8086 82.5511 41.1305 82.5511 47.2376ZM70.4006 45.679H78.4798C78.3207 43.6434 77.112 42.1166 74.7583 42.1166C71.991 42.1166 70.8141 43.6752 70.4006 45.679Z"
        fill="#8000FF"
      />
      <path
        d="M57.9792 38.8077C61.6053 38.8077 64.0227 41.1614 64.0227 45.9326V55.8566H59.9513V47.3321C59.9513 43.547 58.9653 42.4974 56.8342 42.4974C54.4804 42.4974 52.3175 45.1374 52.3175 49.0179V55.8566H48.2461V32.9551H52.3175V40.1118C52.3175 41.1296 52.1266 41.734 51.8085 42.4019C51.6813 42.6882 51.4905 43.1335 51.904 43.2289C52.1584 43.2926 52.2539 43.1017 52.3811 42.8472C53.1445 41.1614 55.0529 38.8077 57.9792 38.8077Z"
        fill="#8000FF"
      />
    </svg>
  </div>
);
export default LoaderFallback;
